import queryString from 'query-string';

// Simple wrapper around window.location.href. This is required for mocking
// (Object.defineProperty on location or location.href incurs a TypeError)
// It has to be exported 'old-style' so that Jasmine's spyOn will work.
export const setHref = (newHref) => {
  window.location.href = newHref;
};

export const encodeKeyValue = (key, value) => {
  const encoded = queryString.stringify({[key]: value});
  return `&${encoded}`;
};

export const removeQueryParam = (key, value) => {
  // custom periods use a slash in the url
  const encoded = encodeKeyValue(key, value)
    .replace(/%2F/g, '/')
    .replace(/\?/g, '')
    .replace(/\&/g, '');

  // paginator uses + instead of %20
  const paginatorEncoded = encoded.replace(/%20/g, '+');

  const existingSearch = window.location.search;
  const newSearch = existingSearch
    .replace(encoded, '')
    .replace(paginatorEncoded, '');

  return newSearch;
};

export const triggerWithoutParam = (category, selection) =>
  setHref(removeQueryParam(category, selection));

export const getQueryParams = () => {
  return queryString.parse(window.location.search);
};

// Add query parameters to given url without altering
// existing params.
export const addQueryParams = (url, queryParams) => {
  if (typeof queryParams === 'string') {
    const separator = !url.includes('?') ? '?' : '&';
    return url + separator + queryParams;
  }

  let params = generateQueryString(queryParams);
  if (url.includes('?')) {
    params = params.replace('?', '&');
  }
  return url + params;
};

/* Process query params and trigger a window.location */
export const triggerQueryParams = (queryParams, toRemove) => {
  const params = generateQueryString(queryParams, toRemove);
  window.location = `${window.location.pathname}${params}`;
};

// Process query params
// Reduxed implementations will not send a toRemove array. They
// send the redux calculated desired query params
// Non-reduxed implementations will send the desired query params
// plus an optional toRemove array for cleanup. Desired params are
// combined with current params to avoid loss of sort/filter state
// If toRemove isn't sent, either nothing to remove
// or it's from a reduxed impl. Either way, same behavior
export const generateQueryString = (queryParams, toRemove) => {
  let newParams = queryParams;
  if (toRemove) {
    // Combine current window location params + desired params
    newParams = {
      ...getQueryParams(),
      ...queryParams,
    };
    // Then remove any specified in toRemove
    for (const remove of toRemove) {
      delete newParams[remove];
    }
  }
  const query = queryString.stringify(newParams);
  const params = query ? `?${query}` : '';
  return params;
};

// Convert an iterator of tuples into a serialized query string
// @param entries: iterator of tuples;
//  ex) [['foo', 1], ['bar': 2], ['foo', 3]]
//  => &foo=1&bar=2&foo=3
//
export const serializeEntries = (entries) => {
  const searchParams = new URLSearchParams();
  for (const [key, value] of entries) {
    searchParams.append(key, value);
  }
  return searchParams.toString();
};
